import React from "react";
import { SecurityGuard, SecurityRole, Page403 } from "@duosoftbg/nacid-components";
import ARUniEntryRequestAdminPage from "../views/pages/registers/admin/request/arUni/ARUniEntryRequestAdminPage";
import ARUniEntryRequestAdminViewPage from "../views/pages/registers/admin/request/arUni/ARUniEntryRequestAdminViewPage";

export const requestAdminRoutes = [
  {
    path: "/admin-console/ar-uni-entry-request",
    element: (
      <SecurityGuard checkForRoles={[SecurityRole.AcadrecUniEntryRequestAccept]} displayOnUnauthorized={<Page403 />}>
        <ARUniEntryRequestAdminPage />
      </SecurityGuard>
    ),
  },
  {
    path: "/admin-console/ar-uni-entry-request/view",
    element: (
      <SecurityGuard checkForRoles={[SecurityRole.AcadrecUniEntryRequestAccept]} displayOnUnauthorized={<Page403 />}>
        <ARUniEntryRequestAdminViewPage />
      </SecurityGuard>
    ),
  },
];
